<template>
	<div class="position-relative" style="z-index: 1037;">
    <div class="row no-gutters justify-content-center">
      <div class="fixed-bottom d-block nav-bottom" style="bottom:0px;top: 0;">
        <div class="custom-container-fluid px-0" style="box-shadow: 1px 0px 6px 2px #dfdfdf4f">
          <div class="row justify-content-center no-gutters">
            <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
              <div class="container px-4 py-3 bg-white box-shadow-main popup-scroll" style="height: 100vh">
              	<div class="text-center my-5" v-if="is_load">
		              <loader></loader>
		            </div>
		            <template v-else>
	                <div class="mb-2 pb-1">
	                  <img src="../../../../assets/img/icon/close.png" class="my-2 d-inline-block mr-2 cursor-pointer" width="15" @click="close()">
	                  <p class="mb-0 body-2-2 text-16 font-bold d-inline-block">{{$t('hotel.special-request.title')}}</p>
	                </div>
	                <div class="scroll-hide-mobile popup-scroll-body">
	                  <p class="mb-4 body-2-2 font-regular">{{$t('hotel.special-request.desc')}}.</p>
	                  <div class="mb-4 pb-2 border-bottom">
	                    <template v-for="(item,index) in list">
	                    	<specialRequestItem @toggleSelect="assignData" :item="item" :index="{index: index,total: list.length}"></specialRequestItem>
	                    </template>
	                  </div>
	                  <div class="mb-4 pb-3 border-bottom">
	                    <form>
	                      <div class="mb-3">
	                        <p class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.in" :class="{'label-active':show_label.in}">{{$t('hotel.check-in-time')}}</p>
	                        <input type="time" class="form-control body-2-2 text-14 mb-1" :placeholder="$t('hotel.date.check-in')" @focus="toggleLabel('in')" @blur="toggleLabel('in',false)" v-model="form.in">
	                        <p class="mb-0 body-2 font-regular text-12 sub-label">{{$t('hotel.special-request.request-check-in')}}</p>
	                      </div>
	                      <div class="mb-3">
	                        <p class="mb-0 bg-white body-2 text-12 font-regular px-1 delay" v-show="show_label.out" :class="{'label-active':show_label.out}">{{$t('hotel.check-out.time')}}</p>
	                        <input type="time" class="form-control body-2-2 text-14 mb-1" :placeholder="$t('hotel.date.check-out')" @focus="toggleLabel('out')" @blur="toggleLabel('out',false)" v-model="form.out">
	                        <p class="mb-0 body-2 font-regular text-12 sub-label">{{$t('hotel.special-request.request-check-out')}}</p>
	                      </div>
	                      <div class="mb-3">
	                        <textarea class="form-control w-100 body-2-2 text-14" rows="4" v-model="form.note" :placeholder="$t('hotel.special-request.other-request')"></textarea>
	                      </div>
	                    </form>
	                  </div>
	                  <div class="height-75px"></div>
	                </div>
	                <transition name="fade">
	                  <template>
	                    <div class="position-relative" style="z-index: 1037;">
	                      <div class="row no-gutters justify-content-center">
	                        <div class="fixed-bottom d-block" style="bottom:0px">
	                          <div class="custom-container-fluid px-0">
	                            <div class="row justify-content-center no-gutters">
	                              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
	                                <div class="container bg-white px-4 py-2">
	                                  <button type="button" class="button-primary w-100" @click="submit()">{{$t('hotel.special-request.add-request')}}</button>
	                                </div>
	                              </div>
	                            </div>
	                          </div>
	                        </div>
	                      </div>
	                    </div>
	                  </template>
	                </transition>
	              </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import {get} from '@/services/index.js'
	import {mapGetters,mapMutations} from 'vuex'
	import specialRequestItem from '@/components/hotel/be/mobile/specialRequestItem'

	export default{
		components: {
			specialRequestItem
		},
		data(){
			return{
				is_load: false,
				list: [],
				form:{
					in: '',
					out: '',
					note: ''
				},
				show_label:{
					in: false,
					out: false 
				}
			}
		},
		mounted() {
			this.loadData()
		},
		methods:{
			...mapGetters(['getMerchant','getBeCart']),
			...mapMutations(['BeManipulateSpecialReq']),
			loadData(){
				this.is_load = true
				get("CORE_HOTEL","hotel-special-request",{
					merchant_id: this.getMerchant().id
				}).then(response=>{
					let res = response.data
					if(res.success){
						for(let item of res.data){
							let record = this.getBeCart().special_request.findIndex(x=>x.data.id == item.id)
							let params = {
								data: item,
								is_checked: (record != -1) ? true : false,
								note: (record != -1) ? this.getBeCart().special_request[record].note : ''
							}
							this.list.push(params)
						}
						this.form = {
							in: this.getBeCart().custom_time.check_in,
							out: this.getBeCart().custom_time.check_out,
							note: this.getBeCart().note
						}
					}else{
						console.log("Error while load special request : ", res.message)
					}
					this.is_load = false
				})
			},
			toggleLabel(key,focus=true){
				this.show_label[key] = (focus || this.form[key] != '') ? true : false;
      },
      assignData(data){
      	let local = data.data
      	this.list[data.index] = local
      },
      submit(){
      	let item_list = this.list.filter(x=> x.is_checked)
      	let params = {
      		special_request: item_list,
      		time:{
      			check_in: this.form.in,
    				check_out: this.form.out
      		},
      		note: this.form.note
      	}

      	this.BeManipulateSpecialReq(params)
      	this.close()
      },
      close(){
      	this.$emit('close','close')
      }
		}
	}
</script>	


// WEBPACK FOOTER //
// src/components/hotel/be/mobile/specialRequest.vue